<template>
    <div  class="form-page">
        <my-form v-model="form" readonly table>
            <my-form-item-group title="查看中标公告">
                <el-form-item label="公告名称" prop="by1" class="table-full-row">
                    {{form.by1}}
                </el-form-item>
                <el-form-item label="招标项目" prop="zbproname" class="table-full-row" v-if="type!='1'">
                    {{zbprocode}}--{{zbproname}}
                </el-form-item>
                <el-form-item label="标段名称" prop="bdname">
                    {{form.bdname}}
                </el-form-item>
                <el-form-item 
                    label="中标公告类型" 
                    class="table-full-row">
                        <span v-if="form.ggxzcode=='1'||!form.ggxzcode">正常</span>
                        <span v-if="form.ggxzcode=='2'">变更</span>
                </el-form-item>
                <el-form-item label="中标人" prop="zbdwname">
                    {{form.zbdwname}}
                </el-form-item>
                <el-form-item label="中标价格" v-if="form.bjlx==='2'||form.bjlx==='3'||form.bjlx==='4'"  class="table-full-row">
                    {{form.zbbj}}
                </el-form-item>
                <el-form-item label="委托价格" v-if="form.bjlx==='2'||form.bjlx==='3'||form.bjlx==='4'">
                    {{form.wtbj}}
                </el-form-item> 
                <el-form-item label="中标价格" v-if="form.bjlx!=='2'&&form.bjlx!=='3'&&form.bjlx!=='4'" class="table-full-row">
                    {{form.zbjg}}{{form.jgdwname}}{{form.bzname}}
                </el-form-item>
                <el-form-item label="委托金额" v-if="form.bjlx!=='2'&&form.bjlx!=='3'&&form.bjlx!=='4'" prop="e_wtje">
                    {{form.e_wtje}}
                </el-form-item> 
                <el-form-item label="节资率" v-if="form.bjlx!=='2'&&form.bjlx!=='3'&&form.bjlx!=='4'" prop="e_jzl">
                    {{form.e_jzl}}
                </el-form-item>
                <el-form-item label="定标时间" v-if="form.bidevaladdr!=null&&type!='1'" prop="contractawardtime" class="table-full-row">
                    {{form.contractawardtime}}
                </el-form-item>
                <el-form-item label="代理收费金额(元)" v-if="form.bidevaladdr!=null&&type!='1'"  prop="feeamount" class="table-full-row">
                    {{form.feeamount}}
                </el-form-item>
                <el-form-item label="评标地点" v-if="form.bidevaladdr!=null&&type!='1'"  prop="bidevaladdr" class="table-full-row">
                    {{form.bidevaladdr}}
                </el-form-item>
                <el-form-item label="报价类型" prop="bjlx" v-if="type!='1'">
                    <div v-if="form.bjlx==='2'">费率/比率/优惠率/合格率等</div>
                    <div v-if="form.bjlx==='3'">单价</div>
                    <div v-if="form.bjlx==='4'">其他形式</div>
                    <div v-if="form.bjlx==='1'||form.bjlx===''">金额</div>
                </el-form-item>
                <el-form-item label="中标/投标价格" prop="yccontent" v-if="(form.bjlx==='1'||form.bjlx==='')&&type!='1'">
                    <div v-if="form.bjlx==='1'||form.bjlx===''||form.bjlx===null||form.bjlx===undefined">
                        {{form.zbjg}}{{form.jgdwname}}{{form.bzname}}                       
                    </div>
                    <div v-else>
                        {{form.zbbj}}
                    </div>
                </el-form-item>
                      
                
                <template v-if="$route.query.isXt!=='1'">
                    <el-form-item label="与中标候选人不一致原因" v-if="form.deptcode==='4'" prop="ext_reason" class="table-full-row">
                        {{form.ext_reason}}
                    </el-form-item>     
                    <el-form-item label="中标人在投标文件中填报的资格能力条件" v-if="form.deptcode==='4'&&type!='1'" prop="ext_tenderability" class="table-full-row">
                        {{form.ext_tenderability}}
                    </el-form-item>   
                </template>
                
                <el-form-item label="中标单位所属地区编码" v-if="type!='1'" prop="ext_tendercitycode">
                    {{form.ext_tendercitycode}}
                </el-form-item>     
                <el-form-item label="中标单位所属地区名称" v-if="type!='1'" prop="ext_tendercityname">
                    {{form.ext_tendercityname}}
                </el-form-item>    

                <el-form-item 
                    label="是否联合体">
                        <span v-if="form.islht=='1'">是</span>
                        <span v-if="form.islht=='0'">否</span>
                </el-form-item>

                <el-form-item 
                    label="联合体成员">
                        <span>{{form.lhtcy}}</span>
                </el-form-item>
                
                <el-form-item label="招标代理项目经理" v-if="type!='1'" prop="zbdlxmjl">
                    {{form.zbdlxmjl}}
                </el-form-item>     
                <el-form-item label="招标代理项目经理身份证号" v-if="type!='1'" prop="zbdlxmjl_sfzh">
                    {{form.zbdlxmjl_sfzh}}
                </el-form-item>    
                <el-form-item label="其它说明" prop="qtsm" class="table-full-row">
                    {{form.qtsm}}
                </el-form-item>       
                <el-form-item label="公告内容" prop="detail" class="table-full-row">
                    <div v-html="form.detail"></div>
                </el-form-item>
                <el-form-item label="附件" class="table-full-row">
                    <my-upload readonly  :file-guid="form.fileguid"></my-upload>
                </el-form-item>
            </my-form-item-group>
        </my-form>
    </div>
</template>

<script>
import LIST_PAGE_MIXIN from '@views/mixins/list-page'
export default {
    mixins: [LIST_PAGE_MIXIN],
    data() {
        return{
            form:{},
            zbproname:'',
            zbprocode:'',
            type:'',//判断是审核进来  type=1 是
        }
    },
    computed: {
        
    },
    watch: {

    },
    methods: {


    },
    created() {
        
    },
    mounted() {
        var that=this;
        if(this.$route.query.ggcode!=undefined){
            that.$get(`${this.getGetters('bidUrl')}/revision/DingBiao/ZhongBiaogg/detail.json`,{ggcode:this.$route.query.ggcode,isXt:this.$route.query.isXt}, (data, res) => {
                that.form=data.model;
                that.zbproname=data.zbproname;
                that.zbprocode=data.zbprocode;
            });
        };
        //判断是从审核菜单进来  type=1 是
        this.type = this.getQuery('type')
        if(this.type=='1'){
            that.$get(`${this.getGetters('bidUrl')}/manage/business/auditzbjggg/detail.json`,{
                id:this.getQuery('id')
            }, (data, res) => {
                that.form=data.model;

            });
            
        }
    }
}
</script>

<style scoped lang="scss">

</style>
